import axios from 'axios';

const api = axios.create({
  baseURL: 'https://laravel.topdevit.com/api',
  headers: {
    'Accept': 'application/vnd.api+json', // or 'application/json' depending on API
    'Content-Type': 'application/json',
  },
});

// Optional: Add Authorization token from session/local storage
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('auth_token'); // or localStorage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
